export const getColumns = (actions: Record<string, any>) => {
  return [
    {
      title: '商机ID',
      dataIndex: 'trackPlanId',
      width: 190,
      render: actions.IdRender,
    },
    {
      title: '订单号',
      dataIndex: 'orderCode',
      width: 190,
      render: actions.orderIdRender,
    },
    {
      title: '需求标签',
      dataIndex: 'bizType',
      width: 140,
      render: actions.bizTypeRender,
    },
    {
      title: '设计师',
      dataIndex: 'designer',
      width: 100,
    },
    {
      title: '签单日期',
      dataIndex: 'signTime',
      width: 180,
      render: actions.timeRender,
    },
    {
      title: '订单金额（元）',
      dataIndex: 'signAmount',
      width: 160,
    },
    {
      title: '签单产品',
      dataIndex: 'productName',
      width: 180,
      ellipsis: true,
    },
    {
      title: '商机状态',
      dataIndex: 'statusDesc',
      width: 140,
    },
    {
      title: '成交状态',
      dataIndex: 'dealStatusName',
      width: 120,
    },
    {
      title: '订单状态',
      dataIndex: 'orderStatus',
      width: 120,
      render: actions.orderStatusRender,
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 240,
      render: actions.actionRender,
      fixed: 'right',
    },
  ]
}
